import { render } from "./AlliedCultureCrest.vue?vue&type=template&id=26e8d8ae"
import script from "./AlliedCultureCrest.vue?vue&type=script&lang=js"
export * from "./AlliedCultureCrest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__